// 🗣️ ESCUCHA Y ELIGE ENTRE VOCES — Parte II §0 y §2 del documento maestro.
//
// Mide discriminación de tono / registro / tono emocional.
// Spec visual del documento:
//   · "Mismo botón de audio, pero las opciones de respuesta son emojis grandes
//      (48-64px) con una palabra corta debajo, no oraciones."
//   · "Layout horizontal tipo 'reacciones de Slack' para que se sienta lúdico,
//      no examinador."
import { useState } from 'react';
import AudioPlayer from './AudioPlayer';

export default function SlideEscuchaVoces({ slide, onAnswer, locked }) {
  const [audioDone, setAudioDone] = useState(false);
  const [picked, setPicked] = useState(null);

  const handlePick = (opt) => {
    if (picked || locked) return;
    setPicked(opt.id);
    onAnswer(opt.correct);
  };

  return (
    <>
      <AudioPlayer slide={slide} onFinished={() => setAudioDone(true)} />

      {audioDone && (
        <>
          <p className="ob-subhead">{slide.question}</p>
          <div className="ob-tone-row">
            {slide.options.map((opt) => {
              const revealed = picked !== null;
              const cls = revealed ? (opt.correct ? ' ob-correct' : ' ob-dimmed') : '';
              return (
                <button
                  key={opt.id}
                  type="button"
                  className={`ob-tone${cls}`}
                  onClick={() => handlePick(opt)}
                  disabled={revealed || locked}
                >
                  <span className="ob-tone-emoji" aria-hidden="true">{opt.emoji}</span>
                  <span>{opt.text}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}
